<script>
import { mapGetters } from "vuex";
import HorizontalStackedBarChart from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.vue";

export default {
  name: "TrackerEmployeesByOrganizationSize",
  components: { HorizontalStackedBarChart },
  data() {
    return {
      colors: {
        label_tracker_size_msme: "#19A39C",
        label_tracker_size_largeEnterprise: "#F32474",
        label_tracker_size_cooperative: "#B7C51C",
        label_tracker_size_academicInstitution: "#22C2E5",
        label_tracker_size_civilSocietyOrganization: "#FFA700",
        label_tracker_size_governmentAgency: "#CE51BF"
      },
      groups: [
        "label_tracker_size_msme",
        "label_tracker_size_largeEnterprise",
        "label_tracker_size_cooperative",
        "label_tracker_size_academicInstitution",
        "label_tracker_size_civilSocietyOrganization",
        "label_tracker_size_governmentAgency",
      ],
      config: {
        width: 400,
        height: 220,
        marginTop: 0,
        marginBottom: 0,
        axisLabelSpacePercentage: 35,
      },
      employeesByOrganizationSize:[]
    };
  },
  computed: mapGetters(["getTrackerEmployeesByOrganizationSize"]),
  mounted() {
    this.formatEmployeesByOrganizationSize()
  },
  watch: {
    'getTrackerEmployeesByOrganizationSize.data': {
 handler:     function() {
        this.formatEmployeesByOrganizationSize()
      }
    },deep:true
  },
  methods: {
    formatEmployeesByOrganizationSize: function () {
      this.employeesByOrganizationSize= this.getTrackerEmployeesByOrganizationSize.data.filter(empl=>!!empl._id).map(employees => {
        return {
          group: employees._id,
          subGroup: employees._id,
          value: employees.count,
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <horizontal-stacked-bar-chart
      :chart-data="employeesByOrganizationSize"
      :colors="colors"
      :custom-group-sorting="groups"
      :config="config"
      :parent-height="false"
    >
    </horizontal-stacked-bar-chart>
  </div>
</template>

<style scoped lang="scss">

</style>
